import script from "./RecordingManagement.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecordingManagement.vue?vue&type=script&lang=ts&setup=true"

import "./RecordingManagement.vue?vue&type=style&index=0&id=0a9bca42&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a9bca42"]])

export default __exports__